import { API_V4_BASE_URL } from 'settings';
import { get, put, del } from './api';

export default {
  fetchUpdates: () => get({ baseURL: API_V4_BASE_URL, url: `/learner/notifications` }),
  readAndUnreadUpdate:(payload: { id: string, read: boolean }) => put({ baseURL: API_V4_BASE_URL, url: `/learner/notification-center/${payload.id}`, data: { read: payload.read } }),
  deleteUpdate: (payload: { id: string }) => del({ baseURL: API_V4_BASE_URL, url: `/learner/notification-center/${payload.id}` }),
  markAllAsRead: () => put({ baseURL: API_V4_BASE_URL, url: `/learner/notification-center/read-all` })
}